import React from 'react'
import { usePhoneFieldsStyles } from './fields.styles'

export const Title = ({ title }) => {
    const fieldsClass = usePhoneFieldsStyles()
    return (
      <p className={fieldsClass.title}>{title}</p>
    )
}
